import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Grandmaster} from "lo-bahamut";
import { SharedModule } from '../_shared/shared.module';
import { CustomCarouselModule } from '../_shared/custom-carousel/custom-carousel.module';
import { ComingSoonModule } from '../coming-soon/coming-soon.module';
import {PrintSearchResultsModule} from "../search-results/print-search-results/print-search-results.module";
import {NlsSearchResultV2Component} from "./nls-search-result-v2.component";
import {HttpClientModule} from "@angular/common/http";

@NgModule({
  declarations: [NlsSearchResultV2Component],
    imports: [
        ComingSoonModule,
        CommonModule,
        SharedModule,
        CustomCarouselModule,
        Grandmaster,
        PrintSearchResultsModule,
        HttpClientModule,
    ],
  exports: [NlsSearchResultV2Component],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NlsSearchResultsV2Module {}
